import {formatDistanceToNow, isValid, parseISO} from 'date-fns'
import {pl} from 'date-fns/locale'
import type {Locale} from 'date-fns'
import {i18n} from '@toolify/client/src/setup/i18n'

export const RELATIVE_DATE_FORMAT = 'relative'

export function isRelativeDateFormat(dateFormat: string | null | undefined): boolean {
  return dateFormat === RELATIVE_DATE_FORMAT
}

function resolveDateFnsLocale(locale?: Locale): Locale | undefined {
  if (locale) {
    return locale
  }
  return i18n.global.locale.value === 'pl' ? pl : undefined
}

export function getRelativeDateLabel(
  date: Date | string | null | undefined,
  locale?: Locale,
): string {
  if (!date) {
    return ''
  }
  const parsedDate = date instanceof Date ? date : parseISO(date)
  if (!isValid(parsedDate)) {
    return ''
  }
  return formatDistanceToNow(parsedDate, {
    addSuffix: true,
    locale: resolveDateFnsLocale(locale),
  })
}

export function getRelativeDateLabelFromParts(
  date: string | null | undefined,
  time: string | null | undefined,
  locale?: Locale,
): string {
  if (!date) {
    return ''
  }
  return getRelativeDateLabel(time ? `${date}T${time}` : date, locale)
}

export function getRelativeDateRangeLabel(
  from: {date?: string, time?: string} | null | undefined,
  to: {date?: string, time?: string} | null | undefined,
  locale?: Locale,
): string {
  const fromLabel = getRelativeDateLabelFromParts(from?.date, from?.time, locale)
  const toLabel = getRelativeDateLabelFromParts(to?.date, to?.time, locale)
  if (fromLabel && toLabel && fromLabel !== toLabel) {
    return `${fromLabel} → ${toLabel}`
  }
  return fromLabel || toLabel
}
